import ProductCmsPage from "components/cms/ProductCmsPage";
import {
  addProductPageTwo,
  getProductPageTwo,
  prepareProductPageTwo,
  updateProductPageTwo,
} from "api/productpagetwo";
import { emptyProductsTwo } from "utils/defaults";

export default function ProductsTwoPage() {
  return (
    <ProductCmsPage
      label="Product two"
      heading="Product two"
      description="/products/two"
      idPrefix="products-two"
      load={getProductPageTwo}
      create={addProductPageTwo}
      update={updateProductPageTwo}
      empty={emptyProductsTwo}
      prepare={prepareProductPageTwo}
    />
  );
}
